import '/index.js';
import '/src/build/global/js/helper.js';

// Sanitizzazione HTML (XSS) — deve essere disponibile come global prima degli editor
import '/src/export/lib/dompurify/dompurify.js';

// File .js
import 'script-loader!/src/build/global/js/form/autonumeric.js';
import 'script-loader!/src/build/global/js/form/phone.js';
import 'script-loader!/src/build/global/js/form/input.js';
import 'script-loader!/src/build/global/js/form/conditional.js';
import 'script-loader!/src/build/global/js/form/maps.js';
import 'script-loader!/src/build/global/js/gmaps.js';
import 'script-loader!/src/build/global/js/fetch.js';
import 'script-loader!/src/build/global/js/utility.js';
import 'script-loader!/src/build/global/js/canvas.js';

import 'script-loader!/src/build/backend/js/utility.js';
import 'script-loader!/src/build/backend/js/ajax.js';
import 'script-loader!/src/build/backend/js/form/editor.js';
import 'script-loader!/src/build/backend/js/form/input.js';
import 'script-loader!/src/build/backend/js/form/file.js';
import 'script-loader!/src/build/backend/js/form/set.js';
import 'script-loader!/src/build/backend/js/form/send.js';
import 'script-loader!/src/build/backend/js/form/inputRow.js';
import 'script-loader!/src/build/backend/js/form/place.js';
import 'script-loader!/src/build/backend/js/alert.js';
import 'script-loader!/src/build/backend/js/modal.js';
import 'script-loader!/src/build/backend/js/bootstrap.js';
import 'script-loader!/src/build/backend/js/jquery.js';

import Address from '/src/build/backend/js/plugin/address.js';
window.Address = Address;

import Billing from  '/src/build/backend/js/plugin/billing.js';
window.Billing = Billing;

// Fogli di stile
import '/src/build/backend/css/header.css';
import '/src/build/backend/css/input.css';
import '/src/build/backend/css/list.css';
import '/src/build/backend/css/order.scss';

// Correzione librerie
import '/src/build/backend/css/lib/summernote.css';
import '/src/build/backend/css/lib/quilljs.css';
import '/src/build/backend/css/lib/fullcalendar.css';
import '/src/build/backend/css/lib/filepond.css';
import '/src/build/backend/css/lib/editorjs.css';
import '/src/build/backend/css/lib/jstree.css';
import '/src/build/backend/css/lib/select2.css';
